export const DEFAULT_COLOR_MAIN = '#16161B';
export const DEFAULT_COLOR_ACCENT = "#FF434C";

export const TYPE_HYBRID = 'hybrid';

// Common settings
export const WIDGET_NAME = 'name';
export const FONT = 'font';
export const BACKGROUND_COLOR = 'backgroundColor';
export const BACKGROUND_OPACITY = 'backgroundOpacityPercent';
export const BACKGROUND_BLUR = 'backgroundBlurSize';
export const ACCENT_COLOR = 'colorAccent';
export const TEXT_COLOR = 'textColor';
export const TITLE = 'title';
export const TITLE_RU = 'titleRu';
export const TITLE_EN = 'titleEn';
export const SUBTITLE = 'subtitle';
export const SUBTITLE_RU = 'subtitleRu';
export const SUBTITLE_EN = 'subtitleEn';
export const SHOW_TITLE = 'showTitle';
export const SHOW_SUBTITLE = 'showSubtitle';
export const TITLE_COLOR = 'titleColor';
export const TITLE_SIZE = 'titleSize';
export const BORDER_RADIUS_SIZE = 'borderRadiusSize';
